import { gql } from "@apollo/client";

export const EVENT_OCCURRENCE_FRAGMENT = gql`
  fragment EventOccurrence on EventOccurrence {
    id
    date
  }
`;
